export enum InboxPathsEnum {
  inboxPage = '/inbox',
}
